export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
          联系我们
        </h2>
        <p className="mt-3 text-sm text-foreground-600">
          内容合作、版权洽谈、广告投放，欢迎通过以下方式与我们取得联系
        </p>

        <div className="mt-8 bg-background-50 rounded-xl border border-background-200/70 p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center bg-accent-100 rounded-xl text-accent-600">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">商务合作</h3>
              <p className="mt-1 text-xs text-foreground-500">business@91video.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-100 rounded-xl text-primary-600">
                <i className="ri-shake-hands-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">内容投稿</h3>
              <p className="mt-1 text-xs text-foreground-500">content@91video.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center bg-secondary-100 rounded-xl text-secondary-600">
                <i className="ri-customer-service-2-line text-xl"></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 whitespace-nowrap">用户反馈</h3>
              <p className="mt-1 text-xs text-foreground-500">support@91video.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}